import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearErrorsFromServer as clearErrorsFromServerAction,
  confirmCompanyRequest as confirmCompanyRequestAction,
  loadCompanyRequests as loadCompanyRequestsAction,
  setConfirmCompanyRequestModalVisibility as setConfirmCompanyRequestModalVisibilityAction,
  setConfirmedSuccessModalVisibility as setConfirmedSuccessModalVisibilityAction,
} from '../../slices/company_request_slice'
import { loadCompanies as loadCompaniesAction } from '../../slices/company_slice'
import CompanyFormModal from '../modals/CompanyFormModal'
import ConfirmCompanyModalContent from './ConfirmCompanyModalContent'
import ConfirmSuccessContent from './ConfirmSuccessContent'

export function ConfirmCompany() {
  const { confirmCompanyRequestModalVisibility, confirmedSuccessModalVisibility, currentRequest } = useSelector(
    (state) => state.companyRequest
  )
  const company = useMemo(() => {
    if (!currentRequest) return

    return currentRequest.company_alias.company
  }, [currentRequest])

  const dispatch = useDispatch()

  const handleSubmit = () => {
    dispatch(confirmCompanyRequestAction({ id: currentRequest.id }))
  }

  const onCloseConfirmCompanyModal = () => {
    dispatch(setConfirmCompanyRequestModalVisibilityAction(false))
  }

  const onCloseConfirmedSuccessModalVisibility = () => {
    dispatch(loadCompaniesAction())
    dispatch(loadCompanyRequestsAction())
    dispatch(clearErrorsFromServerAction('confirm'))
    dispatch(setConfirmedSuccessModalVisibilityAction(false))
  }
  return (
    <>
      <CompanyFormModal open={confirmCompanyRequestModalVisibility}>
        <ConfirmCompanyModalContent company={company} onBack={onCloseConfirmCompanyModal} onNext={handleSubmit} />
      </CompanyFormModal>
      <CompanyFormModal open={confirmedSuccessModalVisibility}>
        <ConfirmSuccessContent title={'company comfirmed!'} onNext={onCloseConfirmedSuccessModalVisibility} />
      </CompanyFormModal>
    </>
  )
}
